/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much can you realistically read in 15 minutes?`)
};

const es_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto se puede leer realmente en 15 minutos?`)
};

const de_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel kann man realistisch in 15 Minuten lesen?`)
};

const nl_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel kun je realistisch lezen in 15 minuten?`)
};

const fr_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien peut-on réellement lire en 15 minutes ?`)
};

const it_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto si può realisticamente leggere in 15 minuti?`)
};

const pt_br2_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto é realista ler em 15 minutos?`)
};

const pt_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto se consegue realisticamente ler em 15 minutos?`)
};

const ja_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15分で実際どのくらい読めますか？`)
};

const zh_timer_u15m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15分钟实际上能读多少内容？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u15m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u15m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u15m_faq4_q", locale)
	if (locale === "en") return en_timer_u15m_faq4_q(inputs)
	if (locale === "es") return es_timer_u15m_faq4_q(inputs)
	if (locale === "de") return de_timer_u15m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u15m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u15m_faq4_q(inputs)
	if (locale === "it") return it_timer_u15m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u15m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u15m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u15m_faq4_q(inputs)
	return zh_timer_u15m_faq4_q(inputs)
};